export abstract class PdfDownloadIndicatorService {
  abstract isDownloading();

  abstract setDownloading(downloading: any);
}
